import { Controller } from 'stimulus';
import { ajax } from '@rails/ujs';
import { prepareJSONRequest } from '../lib/utils';

export default class extends Controller {
  static targets = [
    'active'
  ]

  connect() {
    this.dragSectionCallback = this.updateSections.bind(this);
    if (this.sectionWrapper)
      this.sectionWrapper.addEventListener('dragdrop.change', this.dragSectionCallback);

    if (this.formFieldWrapper) {
      this.addFormFieldCallback = this.addFormField.bind(this);
      this.moveFormFieldCallback = this.moveFormField.bind(this);
      this.formFieldWrapper.addEventListener('copydrag.add', this.addFormFieldCallback);
      this.formFieldWrapper.addEventListener('copydrag.end', this.moveFormFieldCallback);
    }
  }

  disconnect() {
    if (this.sectionWrapper)
      this.sectionWrapper.removeEventListener('dragdrop.change', this.dragSectionCallback);

    if (this.formFieldWrapper) {
      this.formFieldWrapper.removeEventListener('copydrag.add', this.addFormFieldCallback);
      this.formFieldWrapper.removeEventListener('copydrag.end', this.moveFormFieldCallback);
    }
  }

  get sectionWrapper() {
    return this.element.querySelector('.form-builder__sections');
  }

  get sections() {
    return Array.from(this.element.querySelectorAll('.form-builder__section'));
  }

  get formFieldWrapper() {
    return this.element.querySelector('.sequence-builder__blocks');
  }

  get formFieldCount() {
    return this.formFieldWrapper.querySelectorAll('.sequence-builder__block').length;
  }

  updateSections() { /* event param passed */
    this.sections.forEach((element, index) => {
      element.querySelector('.form-builder__section-number').innerText = index + 1;
    });
  }

  addFormField(event) {
    const url = this.formFieldWrapper.dataset.addFormFieldUrl;
    if (!url) { return; }

    const { item } = event.detail;
    const data = JSON.parse(item.dataset.sequenceBlock);
    data.position = this.formFieldSortPosition(event)

    ajax({
      type: 'POST',
      url,
      dataType: 'json',
      data: { sequence_block: data },
      beforeSend: prepareJSONRequest
    });
  }

  moveFormField(event) {
    let url = this.formFieldWrapper.dataset.moveFormFieldUrl;
    if (!url) { return; }

    url = url.replace(':id', event.detail.item.dataset.id);
    const data = new FormData();
    data.append('position', this.formFieldSortPosition(event));

    ajax({
      type: 'POST',
      url,
      dataType: 'json',
      data
    });
  }

  formFieldSortPosition(event) {
    return Math.min(this.formFieldCount, event.detail.newIndex + 1);
  }

  show(e) {
    e.preventDefault();
    const element = document.getElementById(e.currentTarget.dataset.target);

    element.querySelectorAll('.form-builder__field-wrapper').forEach(block => {
      let url = new URL(block.href)

      let searchParams = url.searchParams;
      searchParams.append('sequence_block[position]', e.currentTarget.dataset.position);

      url.search = searchParams.toString();
      block.href = url.toString();
    })

    element.modal.show();
  }

  activeBlock(event) {
    this.iterateBlocks();

    const {id} = event.currentTarget.dataset;
    let element = document.querySelector(`#sequence-block${id}`);

    element.classList.add('sequence-builder__block--active')

    document.querySelector('.slide-menu__close').addEventListener('click', ()=>{
      element.classList.remove('sequence-builder__block--active')
    })
  }

  deactiveBlock() {
    if (!document.querySelector('.slide-menu--open')) {
      this.iterateBlocks();
    }
  }

  iterateBlocks() {
    this.activeTargets.forEach(ele => {
      ele.classList.remove('sequence-builder__block--active')
    })
  }

  changeActionType(event) {
    if (event) { event.preventDefault(); }
    const { url } = event.currentTarget.dataset;
    if (!url) { return; }
 
    ajax({
      type: 'GET',
      url,
      dataType: 'js'
    });
  }
}
